import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { allowedPaths, disallowedPaths } from './utils';
import { BUILD } from '@Utils/config';

const SEOMetaTags: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;

  const shouldBlockPath = (path: string): boolean => {
    if (allowedPaths.includes(path) && BUILD === 'prod') {
      return false;
    }

    return disallowedPaths.some((disallowedPath) => {
      if (disallowedPath.includes('*')) {
        const regex = new RegExp('^' + disallowedPath.replace(/\*/g, '.*') + '$');
        return regex.test(path);
      }
      return path === disallowedPath || path.startsWith(disallowedPath + '/');
    });
  };

  const isBlocked = BUILD === 'prod' ? shouldBlockPath(path) : true;

  useEffect(() => {
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }

    robotsMeta.setAttribute('content', isBlocked ? 'noindex' : 'index, follow');
  }, [path, isBlocked]);
  return null;
};

export default SEOMetaTags;
